import './Home.css';
import mosqueImage from '../assets/mosque.jpg';

export default function Home() {
  return (
    <div className="w-full">
    {/* Hero Section */}
    <section className="relative w-full overflow-hidden bg-dawoodi-navy md:h-screen">

      {/* Background Image */}
      <div className="relative h-40 sm:h-56 md:absolute md:inset-0 md:h-auto bg-cover bg-center bg-no-repeat home-hero-bg">
        <div className="absolute inset-x-0 bottom-0 translate-y-1 h-10 bg-gradient-to-b from-transparent to-dawoodi-navy md:hidden"></div>
        <div className="hidden md:block absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        <div className="hidden md:block absolute inset-0 bg-black/20"></div>
      </div>

      {/* Pattern Overlay - Desktop Only */}
      <div className="hidden md:block absolute inset-0 opacity-5 pointer-events-none home-pattern-overlay"></div>

      {/* Hero Content */}
      <div className="relative md:h-full flex items-center justify-center px-4 py-8 sm:py-10 md:py-0">
        <div className="text-center max-w-4xl mx-auto">
          <div className="flex justify-center mb-4 md:mb-6">
            <div className="w-16 md:w-20 h-1 bg-gradient-to-r from-dawoodi-gold via-dawoodi-gold to-transparent rounded-full"></div>
          </div>

          <h1 className="font-playfair text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight drop-shadow-lg">
            Welcome to the
            <span className="block text-dawoodi-gold">
              Dawoodi Bohra Community of New Jersey
            </span>
          </h1>

          <p className="font-poppins text-sm sm:text-base md:text-xl text-white/90 leading-relaxed drop-shadow-md max-w-2xl mx-auto">
            Here in the heart of the Garden State, the Dawoodi Bohra community has found a home in New Jersey for decades.
          </p>
        </div>
      </div>

      {/* Scroll Arrow - Desktop Only */}
      <div className="hidden md:block absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg className="w-6 h-6 text-dawoodi-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-dawoodi-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="text-center mb-16">
            <h2 className="font-playfair text-2xl md:text-3xl font-bold text-dawoodi-navy mb-4 leading-relaxed max-w-5xl mx-auto">
              "All Creation is a family dependent on Allah Ta'ala. The Most beloved of all Creation to Him, therefore, is the one who benefits His family the most." - Prophet Muhammad (SAW)
            </h2>

            <div className="w-20 h-1 bg-gradient-to-r from-dawoodi-gold to-transparent rounded-full mx-auto"></div>
          </div>


          <div className="grid md:grid-cols-2 gap-12 items-center">

            <div>
              <h3 className="font-playfair text-3xl font-bold text-dawoodi-navy mb-4">
                Who We Are
              </h3>

              <p className="font-poppins text-gray-700 text-lg leading-relaxed mb-4">
                Our members reflect the diversity and creativity of New Jersey itself. From business owners, artists, and information technology experts to engineers, entrepreneurs, and educators, we are united by our shared commitment to faith, learning, and service.
              </p>

              <p className="font-poppins text-gray-600 text-lg leading-relaxed mb-4">
                Our focus on education, family, and community service remains at the core of everything we do.
              </p>

              <p className="font-poppins text-gray-600 text-lg leading-relaxed">
                To learn more, please visit{' '}
                <a
                  href="https://usa.thedawoodibohras.com/community/new-jersey/"
                  className="text-dawoodi-gold underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  the Dawoodi Bohras USA New Jersey page
                </a>.
              </p>
            </div>

            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-r from-dawoodi-gold to-dawoodi-navy rounded-lg opacity-20 blur-lg"></div>

              <img
                src={mosqueImage}
                alt="Mosque Interior"
                className="relative w-full h-96 object-cover rounded-lg shadow-2xl"
              />
            </div>

          </div>
        </div>
      </section>

      {/* Highlights Section */}
      <section id="highlights" className="py-20 bg-gradient-to-br from-dawoodi-navy via-[#10233b] to-[#18324f]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 md:mb-14">
            <p className="font-poppins text-sm md:text-base uppercase tracking-[0.3em] text-dawoodi-gold mb-3">
              Featured Highlights
            </p>
            <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
              Highlights from Ashara Mubaraka 1448H
              <span className="block text-dawoodi-gold">New Jersey Relay Center</span>
            </h2>
          </div>

          <div className="grid gap-8 xl:grid-cols-2">
            <div className="w-full rounded-[28px] overflow-hidden border border-white/15 shadow-[0_25px_80px_rgba(0,0,0,0.35)] bg-black/20 backdrop-blur-sm">
              <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/jDIF10ekaXs"
                  allow="autoplay"
                  allowFullScreen
                  title="New Jersey Ashara 1448 Relay Highlight Video"
                />
              </div>
            </div>

            <div className="w-full rounded-[28px] overflow-hidden border border-white/15 shadow-[0_25px_80px_rgba(0,0,0,0.35)] bg-black/20 backdrop-blur-sm">
              <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/fdmvb8R_gjg"
                  allow="autoplay"
                  allowFullScreen
                  title="1448 Ashara NJ Relay Center Tayyari"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Masjid Section */}
      <section id="masjid" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="mb-12">
            <h2 className="font-playfair text-4xl md:text-5xl font-bold text-dawoodi-navy mb-8">
              Our Masjid
            </h2>

            <div className="grid md:grid-cols-2 gap-12 items-start">

              <div className="rounded-lg overflow-hidden shadow-lg h-80">
                <iframe
                  title="Map showing Al Masjid Al Zainee in East Brunswick, New Jersey"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.5!2d-74.44344951865841!3d40.4150131025046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3cbb1b1b1b1b1%3A0x0!2sAl%20Masjid%20Al%20Zainee%2C%20341%20Dunhams%20Corner%20Rd%2C%20East%20Brunswick%2C%20NJ%2008816!5e0!3m2!1sen!2sus!4v1700000000000"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  style={{ cursor: 'pointer' }}
                ></iframe>
              </div>

              <div>
                <div className="mb-6">

                  <h3 className="font-playfair text-2xl font-bold text-dawoodi-navy mb-4">
                    Al Masjid Al Zainee, New Jersey
                  </h3>

                  <p className="font-poppins font-semibold text-dawoodi-navy mb-1">
                    Address:
                  </p>

                  <p className="font-poppins text-gray-700 text-lg">
                    341 Dunhams Corner Rd, East Brunswick, NJ 08816
                  </p>

                  <p className="font-poppins text-gray-600 text-lg leading-relaxed mt-6">
                    Nestled amongst a number of houses of worship in the East Brunswick area, including local churches and synagogues, our masjid exemplifies the values of sanctity of worship to the Creator and religious tolerance.
                  </p>

                  <p className="font-poppins text-gray-600 text-lg leading-relaxed mt-4">
                    True to the spirit of the Garden State, our nearly ten-acre campus houses a green arboretum-like landscape with wooded plants, including many of local New Jersey origin.
                  </p>

                </div>
              </div>

            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
